import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import { ExtractorSessionLifeCycleOptions, getExtractorSessionLifeCycleLabel, getSortedLifeCycles, initialExtractorSessionLifeCycleFilter } from "./FilterTypes/ExtractorSessionLifeCycleFilterType";
import { FilterContext } from "../FilterContext";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const ExtractorSessionLifeCycleFilter = () => {
  const title = RESX.Status.resxStatus;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("extractorSessionLifeCycle", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedLifeCycles(filter).map(getExtractorSessionLifeCycleLabel).join(", ")}</>,
    hasValue: (filter) => filter.selectedLifeCycles.length > 0,
    reset: () => initialExtractorSessionLifeCycleFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedLifeCycles, b.selectedLifeCycles)
  });
  useEffect(() => {
    setInitialValue("extractorSessionLifeCycle", initialExtractorSessionLifeCycleFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedLifeCycles, setSelectedLifeCycles] = React.useState(initialExtractorSessionLifeCycleFilter.selectedLifeCycles);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedLifeCycles(getValue("extractorSessionLifeCycle").selectedLifeCycles);
    setPopupOpen(true);
  };

  const onLifeCycleToggle = (newLifeCycle: server.dto.ExtractorSessionLifeCycles) => {
    const isSelected = selectedLifeCycles.some(lifeCycle => lifeCycle === newLifeCycle);
    const newSelection = isSelected
      ? selectedLifeCycles.filter(lifeCycle => lifeCycle !== newLifeCycle)
      : [...selectedLifeCycles, newLifeCycle];
    setSelectedLifeCycles(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("extractorSessionLifeCycle", { selectedLifeCycles });
    setPopupOpen(false);
  };
  const checkedMap = new Set(selectedLifeCycles);

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<>
        <div className="margin-bottom flex-column gap-small">
          {ExtractorSessionLifeCycleOptions.map((option, index) =>
            <div key={option.value}>
              <Checkbox
                autoFocus={index === 0}
                keyboardNavigationOptions={VerticalKeyboardNavigationGroup("extractorSessionLifeCycles")}
                onChange={() => { onLifeCycleToggle(option.value); }}
                checked={checkedMap.has(option.value)}
                label={getExtractorSessionLifeCycleLabel(option.value)}
              />
            </div>
          )}
        </div>

        <Button fluid onClick={onApply} primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default ExtractorSessionLifeCycleFilter;
